import React from 'react';
import { Card, Space, Button} from 'antd';


interface OrderNotificationCardProps {
    orderId: string | undefined,
    orderNotificationDate: string | undefined,
    requestHandler: () => void,
    isEditMode?: boolean
}

export const OrderNotificationCard: React.FC<OrderNotificationCardProps> = ({
    orderId,
    orderNotificationDate,
    requestHandler,
    isEditMode = false
}) => {


    const formatDateSleek = (isoString: string | undefined): string | undefined => {
        // Return undefined if the date doesn't exist yet
        if (!isoString) return undefined;

        // The Date constructor seamlessly converts the ISO string back into a Date object
        const dateObject = new Date(isoString);

        return new Intl.DateTimeFormat('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false // Forces 24-hour time 
        }).format(dateObject).replace(',', ''); 
    }

    return (
        <Card 
        title='Notifications' 
        loading={orderId === undefined}
        extra={<Button onClick={requestHandler} disabled={isEditMode}>Send Confirmation</Button>}>
            <p>
                <Space>
                    <span>Email date:</span>
                    <span>{orderNotificationDate ? formatDateSleek(orderNotificationDate) : "No data"}</span>
                </Space>
            </p>
        </Card>
    );
}